/**
 * Top-up Success Page
 *
 * Where Stripe sends users after paying for a credit top-up. The credits are
 * added by the Stripe webhook, which can land a second or two after the redirect,
 * so this polls the balance a few times before giving up gracefully. Web only
 * (not registered on the iOS app, like the other billing pages).
 */

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import useCredits, { refreshCredits } from '../hooks/useCredits'
import { billingApi } from '../services/api'
import CreditUsageBar from '../components/CreditUsageBar'

const NAVY = '#0A1F44'
const BLUE = '#1E5BD6'

export default function BillingTopupSuccess() {
  const credits = useCredits()
  const [attempts, setAttempts] = useState(0)
  // The balance when this page first had one: credits arriving later means the
  // webhook has landed. State, not a ref, so the comparison renders correctly.
  const [baseline, setBaseline] = useState(null)
  useEffect(() => {
    billingApi.getStatus()
      .then(({ data }) => setBaseline(data?.credits?.topupCredits || 0))
      .catch(() => setBaseline(0))
  }, [])

  const arrived = !!credits && baseline !== null && (credits.topupCredits || 0) > baseline

  useEffect(() => {
    if (arrived || attempts >= 6) return undefined
    const t = setTimeout(() => { refreshCredits(); setAttempts((n) => n + 1) }, 2000)
    return () => clearTimeout(t)
  }, [arrived, attempts])

  return (
    <div style={{ maxWidth: 520, margin: '80px auto', textAlign: 'center', padding: 24 }}>
      <h1 style={{ color: NAVY, fontSize: 28, marginBottom: 12 }}>
        {arrived ? 'Your credits are added' : 'Thanks for your top-up'}
      </h1>
      <p style={{ color: '#445', fontSize: 16, lineHeight: 1.5 }}>
        {arrived
          ? 'Your top-up credits are ready to use. They expire 1 month after purchase.'
          : attempts >= 6
            ? 'Your payment went through. Your balance is shown below; if the credits are not there yet, refresh this page in a minute.'
            : 'Confirming your payment...'}
      </p>
      <div style={{ margin: '18px auto 0', maxWidth: 360, textAlign: 'left' }}><CreditUsageBar /></div>
      <Link
        to="/chat"
        style={{
          display: 'inline-block', marginTop: 24, background: BLUE, color: '#fff',
          textDecoration: 'none', borderRadius: 10, padding: '12px 22px', fontWeight: 600,
        }}
      >
        Go to JAI
      </Link>
    </div>
  )
}
